import { MediaListComponent } from "../MediaListComponent";
import { TopicManager } from "../../managers/TopicManager";
import { MediaListModel } from "../../models/MediaListModel";
import { vp } from "../../managers/vp";
import { MediaItemComponent } from "../MediaItemComponent";
import { DomUtils } from "socios-tools/utils/DomUtils";
import { ProjectDomUtils } from "../../libs/utils/ProjectDomUtils";
const mediaItemFactory = require("../../../html/MediaItem.handlebars");
export class GridList extends MediaListComponent {
    constructor() {
        super(...arguments);
        this._loadingNextItems = false;
    }
    init() {
        this._loader = this.getHtml('loader');
        this._list = this.getHtml('list');
        this._model = new MediaListModel({
            items: this.getHtmlList('MediaItemComponent').map((item) => {
                const data = TopicManager.getDataFromTemplate(item.getAttribute('data-id') || '');
                if (!data) {
                    logger.error('cant find data');
                }
                return data;
            }),
            links: {
                "api:next": this.html.getAttribute('data-next-url') || ''
            }
        });
        document.addEventListener('scroll', (e) => {
            this.checkForNextPage();
        });
        this.update();
        this.checkForNextPage();
    }
    update() {
        this.updateListItems();
    }
    updateListItems() {
        if (this._model) {
            this._model.items.forEach((mediaItem) => {
                this.appendMediaItem(mediaItem);
            });
            vp.components.pushQueue('MediaItemComponent', MediaItemComponent);
        }
    }
    hasMediaItemAppended(item) {
        const items = this.getHtmlList('MediaItemComponent');
        return items.some((itemHtml, index) => {
            return itemHtml.getAttribute('data-id') === item.id;
        });
    }
    appendMediaItem(item) {
        if (!this.hasMediaItemAppended(item)) {
            const itemHtml = DomUtils.createElement('<div class="GridList-item">' + mediaItemFactory(item) + '</div>');
            this._list.appendChild(itemHtml);
            const raw = item.getRawData();
            window['__data_' + raw.id] = raw;
        }
        else {
        }
    }
    checkForNextPage() {
        if (this._model.hasNextLink() && !this._loadingNextItems) {
            const scrollingElement = document.scrollingElement || document.documentElement;
            const nextTrigger = ProjectDomUtils.localToGlobal(this._list).bottom - 100;
            if (nextTrigger < scrollingElement.scrollTop + window.innerHeight) {
                this._loader.style.display = 'flex';
                this._loadingNextItems = true;
                this._model.fetchNextLink().then(() => {
                    this._loadingNextItems = false;
                    this._loader.style.display = 'none';
                    this.update();
                    vp.loadImagesInView();
                    this.checkForNextPage();
                });
            }
        }
    }
}
